<template>
    <PageContent name="企业文化" />
</template>

<script>
    import PageContent from "@/components/common/PageContent.vue";
    export default {
        name: "culture",
        components:{
            PageContent
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/culture.vue